import axios from "axios";

export const getAgoraToken = (data, signal) => {
  let url = "api/loginEndpoints/v1/rtcAgoraToken";
  return axios.post(url, data, { timeout: 15000, ...(signal && { signal }) });
};
export const checkingProviderStatus = (url, passingOject, signal) => {
  return axios.post(url, passingOject, { ...(signal && { signal }) });
};
